import { useEffect, useState } from "react";

/**
 * Devuelve un valor "rezagado" que solo se actualiza tras `delayMs`
 * milisegundos sin cambios en el input. Útil para evitar disparar
 * queries de búsqueda en cada tecla del usuario.
 *
 * Patrón estándar React: setea el valor inmediato en otro `useState`
 * para que el input se sienta responsivo, y consume `useDebounce` en
 * el `queryKey` / `queryFn` que cuestan red.
 */
export function useDebounce<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handler);
  }, [value, delayMs]);
  return debounced;
}
